import React from 'react';

const SuccessStep = ({ submissionId, flowTitle, onStartOver }) => {
  return (
    <div className="text-center py-8" data-testid="success-step">
      {/* Success Icon */}
      <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-6">
        <svg className="w-10 h-10 text-[#2d8a5f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>

      {/* Title */}
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
        You&apos;re all set!
      </h2>

      {/* Flow subtitle */}
      {flowTitle && (
        <p className="text-[#2d8a5f] font-medium mb-4">
          {flowTitle} Assessment Complete
        </p>
      )}

      {/* Description */}
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        Thank you for completing your health intake form. Our team will review your information and get back to you within 24-48 hours.
      </p>

      {/* Reference ID */}
      {submissionId && (
        <div className="bg-gray-50 rounded-xl p-4 mb-8 max-w-sm mx-auto">
          <p className="text-sm text-gray-500">Reference ID</p>
          <p className="text-sm font-mono text-gray-700 mt-1">{submissionId}</p>
        </div>
      )}

      {/* Next Steps */}
      <div className="bg-[#f0faf4] rounded-xl p-6 max-w-md mx-auto text-left">
        <h3 className="font-semibold text-gray-900 mb-3">What happens next?</h3>
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">1</span>
            </div>
            <p className="text-sm text-gray-600">A healthcare provider will review your information</p>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">2</span>
            </div>
            <p className="text-sm text-gray-600">You&apos;ll receive personalized recommendations via email</p>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">3</span>
            </div>
            <p className="text-sm text-gray-600">Start your personalized wellness journey</p>
          </li>
        </ul>
      </div>

      {/* Button */}
      <button
        onClick={()=>{alert('go back to portal')}}
        className="mt-8 px-8 py-3 text-[#2d8a5f] font-medium hover:bg-gray-50 rounded-xl transition-colors"
        data-testid="start-over-button"
      >
       Go back to Portal
      </button>
    </div>
  );
};

export default SuccessStep;
